import Channel from '@shared/classes/channel';
import ChannelList from '../list/channelList/channelList';
import ChannelListContentContainer from '@components/atoms/container/channelListContentContainer';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListInfo from './content/channelListInfo';
import { useContext } from 'react';

interface Props {
  data: Channel[];
  setChannel: (
    channel: Channel | undefined,
    increment: number | undefined
  ) => void;
}

export default function ChannelListContent({ data, setChannel }: Props) {
  const { index, focused, pop } = useContext(ChannelListContext);
  return (
    <ChannelListContentContainer
      animation={'channel-list-content'}
      focused={focused}
      id={'channelListContentContainer'}
    >
      <ChannelList
        circular={true}
        channelsData={data}
        focused={focused}
        currentIndex={index}
        onChangeState={setChannel}
        pop={pop}
      />
      <ChannelListInfo />
    </ChannelListContentContainer>
  );
}
